import ReactDOM from "react-dom";

import { TCreateModalArgs, TCreateModalFunction } from "./types";
import createContainer from "./utils/createContainer";
import renderModal from "./utils/renderModal";

const createModal: TCreateModalFunction = ({ onClose, onReject, onSubmit, ...args }) => {
  const { container, destroy } = createContainer();

  const render = (renderArgs: TCreateModalArgs) => {
    setTimeout(() => {
      ReactDOM.render(
        renderModal({
          ...renderArgs,
          onSubmit: () => onSubmit?.(destroy),
          onClose: () => onClose?.(destroy),
          onReject: () => onReject?.(destroy),
        }),
        container
      );
    });
  };
  render(args);

  return { destroy };
};

export default createModal;
